import { useEffect, useState } from "react";
import { Context } from "../../App";
import Default from "../../components/Header/Default";
import { Generic } from "../../components/error/Generic";
import LoadingDefault from "../../components/Loading/LoadingDefault";
import { getAllOperations } from "../../api/calculator/calculatorServices";
import {
  isListOperations,
  formmatDate
} from "../../utils/table/FetchOperationsValidator";
import CalculatorOperationsList from "../../components/Table/CalculatorOperationsList";

function OperationsList() {
  const [status, setStatus] = useState("Loading");
  const [operations, setOperations] = useState([]);
  const [warn, setWarn] = useState("");

  async function getOperations() {
    const res = await getAllOperations();
    if (res.ok) {
      const operationsSaved = res.data;
      if (isListOperations(operationsSaved)) {
        let dataModified = operationsSaved.map((item) => {
          item.time_expiration = formmatDate(item.time_expiration);
          return item;
        });
        setOperations(dataModified);
        setStatus("Valid Data");
      }
    } else if (res.status !== void 0 && res.status !== 0 && res.message !== void 0 && typeof res.message === "string") {
      setWarn(res.message);
      setStatus("");
    } else if (res.status !== void 0 && res.status === 0) {
      setStatus("No Internet");
    } else {
      setStatus("Invalid Data");
    }
  }

  useEffect(() => {
    getOperations();
  }, []);

  if (status === "") {
    return (
      <>
        <Default />
        <Generic message={warn} />
      </>
    );
  }

  if (status === "Loading") {
    return (
      <>
        <Default />
        <LoadingDefault />
      </>
    );
  }

  if (status === "Invalid Data") {
    return (
      <>
        <Default />
        <Generic message={"Dados da calculadora inválidos."} />
      </>
    );
  }

  if (status === "No Internet") {
    return (
      <>
        <Default />
        <Generic
          message={
            "Sem conexão. Por favor, verifique sua internet e tente novamente."
          }
        />
      </>
    );
  }

  return (
    <>
      <Default />
      <CalculatorOperationsList
        operations={operations}
        getOperations={getOperations}
      />
    </>
  );
}

export default function BonusListPage({ statusMode, setStatusMode }) {
  return (
    <Context.Provider value={{ statusMode, setStatusMode }}>
      <OperationsList />
    </Context.Provider>
  );
}
